import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledDialog = styled(Dialog)`
  .MuiDialog-container {
    width: 100vw;
  }
  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }
  .dialog-wrapper {
    display: flex;
    gap: 12px;
    padding: 16px 48px;
    flex-direction: column;
    align-items: center;
  }
  .MuiPaper-root {
    border-radius: 16px;
  }

  .content-wrapper {
    flex: 1;
    width: ${(props) => props.dialogDevice && '566px'};
  }
  .dialog-title {
    font-weight: 500;
    padding: 0;
    color: ${COLOR.dark};
    margin-left: ${(props) => props.dialogDevice && '16px'};
    text-align: center;
    position: relative;
  }
  .icon {
    width: ${(props) => (props.isPopupTransfer ? '80px' : '120px')};
    height: ${(props) => (props.isPopupTransfer ? '80px' : '120px')};
  }
  .title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 12px;
    color: ${COLOR.black.default};
  }
  .description {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 12px;
    color: ${COLOR.black.default};
  }
  .dialog-action {
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  button {
    text-transform: unset;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
    flex: 1 0 0;
    max-width: 170px;
  }
  .outlined-button {
    border: none;
    outline: 1px solid ${COLOR.label[16]};
    outline-offset: -1px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .MuiDialog-container {
      width: 100vw;
      height: 100dvh;
    }

    .MuiPaper-root {
      margin: 16px;
    }

    .close-button {
      position: absolute;
      top: 8px;
      right: 8px;
    }
    .dialog-wrapper {
      display: flex;
      gap: 12px;
      padding: 16px 16px;
      flex-direction: column;
      align-items: center;
    }
    .MuiPaper-root {
      border-radius: 16px;
    }
    .dialog-title {
      font-weight: 500;
      color: ${COLOR.dark};
      margin-left: ${(props) => props.dialogDevice && '16px'};
      text-align: center;
      position: relative;
    }

    .image-container {
      height: ${(props) => (props.isPopupTransfer ? '80px' : '120px')};
    }
    .icon {
      height: 100%;
      display: ${(props) => props.hideImageOnMobileWeb && 'none'};
    }
    .title {
      color: ${COLOR.black.default};
      text-align: center;
      font-size: 16px;
      font-weight: 700;
    }
    .description {
      font-size: 14px;
      font-weight: 400;
      color: ${COLOR.black.default};
    }
    .dialog-action {
      display: flex;
      align-items: center;
      padding: 0 0 0 0;
    }
    button {
      text-transform: unset;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 700;
      flex: 1 0 0;
      max-width: 168px;
      padding: 12px 0px;
    }
    .upgrade-standard-button {
      border: none;
      outline: 1px solid ${COLOR.label[16]};
      outline-offset: -1px;
    }
  }
`;
export { StyledDialog };
